import React from 'react';
import { useGetInspectionScoring } from '../../../../services/api/generated/client';
import { ErrorAwareAlertBox } from '../../../modules/ErrorAwareAlertBox/ErrorAwareAlertBox';
import EditPropertyDetails from '../../../forms/EditPropertyDetails';
import { unwrapModel } from '../../../../services/api/unwrapModel';
export const EditPropertyDetailsModalWrapper = (props) => {
    const { data: response, isError, error, isLoading, } = useGetInspectionScoring(props.inspection.id);
    if (isLoading) {
        return null;
    }
    if (isError) {
        return React.createElement(ErrorAwareAlertBox, { error: error, noun: "Inspection" });
    }
    const scoring = unwrapModel(response);
    return (React.createElement(EditPropertyDetails, { onClose: props.onClose, onSuccess: props.onSuccess, inspection: props.inspection, HHSRSScoring: scoring }));
};
